export const styles = {
  LpRowContainer: {
    justifyContent: 'space-between',
    padding: '5px',
    ':hover': { background: 'white4', cursor: 'pointer' },
  },
  displayRowsContainer: { height: '300px', overflow: 'auto', background: 'white3', borderRadius: '10px' },
  inputContainer: { position: 'relative', margin: '10px 0px 15px 0px' },
}
